import React from 'react';
import { connect } from 'dva';
import { TreeSelect } from 'antd';
import { isEmpty } from 'lodash';
import InfoBar from '@/components/info-bar';

class DocProduct extends React.Component {
  state = {
    productDocs: {},
  };

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch({ type: 'contentModel/getProductDocs' }).then((productDocs) =>
      this.setState({ productDocs })
    );
  }

  formatTreeData = (data, prefix = '') => {
    if (typeof data !== 'object') return data;
    if (isEmpty(data)) return null;

    const SPLIT_MARK = '>';
    let res = [];
    Object.entries(data).forEach(([key, value]) => {
      let children = this.formatTreeData(value, prefix + key + SPLIT_MARK);

      if (!children) return;
      if (typeof children === 'string') {
        const [docType, docVersion] = prefix.split(SPLIT_MARK);
        res.push({
          title: key,
          value: prefix + key,
          selectable: true,
          params: {
            docType,
            docVersion,
            docTitle: key,
            docLink: children,
          },
        });
      } else {
        res.push({
          title: key,
          value: prefix + key,
          selectable: false,
          children,
        });
      }
    });

    return res.length ? res : null;
  };

  render() {
    const {
      userModel: { profile },
    } = this.props;
    const { productDocs } = this.state;

    return (
      <div>
        <InfoBar
          title="Product Documentation"
          icon="MCP_app_menu_Audit_logs"
          color="#0271bc"
          subtitle="Select the product documentation to review."
        />
        <div className="container page white-bg account-info-container">
          <h3>Select the product documentation</h3>
          <p>Click below to select the product, version and documentation you wish to review.</p>
          <TreeSelect
            showSearch
            allowClear
            treeLine
            placeholder="Product type, version and documentation"
            treeExpandAction="click"
            style={{ width: 350, minWidth: 'fit-content' }}
            dropdownMatchSelectWidth={false}
            treeData={this.formatTreeData(productDocs)}
            onSelect={(_, { params }) => {
              if (!params || !params.docLink) return;
              window.open(params.docLink);

              /* Matomo */
              _paq.push([
                'trackEvent',
                'Product Document',
                'Read',
                JSON.stringify({
                  type: params.docType,
                  version: params.docVersion,
                  title: params.docTitle,
                  username: profile.username,
                }),
              ]);
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect(({ userModel }) => ({
  userModel,
}))(DocProduct);
